import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import authConfig from '../../authConfig';
import { useSelector, useDispatch } from "react-redux";
/**
 * MemberFutureMeetingsSelector
 * Fetches and allows a member to select from their future meetings.
 *
 * @param {Object} props
 * @param {Function} props.onSelect - Callback when a meeting is selected
 */
const MemberFutureMeetingsSelector = ({ onSelect,label,required=false }) => {
    const [futureMeetings, setFutureMeetings] = useState([]);
    const [selectedMeetingId, setSelectedMeetingId] = useState('');
    const [loading, setLoading] = useState(true);
    const isLoggedIn = useSelector(state => state.auth.isLoggedIn);
    const member = useSelector(state => state.auth.user ? state.auth.user : null);

    useEffect(() => {
        const fetchMeetings = async () => {
            setLoading(true);
            try {
                const response = await fetch(authConfig.api.urls.getMemberFutureMeetingsList, {
                    credentials: 'include',
                });
                const data = await response.json();
                // Map API data to expected format
                const meetings = data.map(m => ({
                    id: m.id,
                    title: m.meeting.titleEn,
                    committee: m.committee.nameEn,
                    date: m.start,
                }));
                setFutureMeetings(meetings);
            } catch (error) {
                setFutureMeetings([]);
            }
            setLoading(false);
        };
        fetchMeetings();
    }, []);

    const handleChange = (e) => {
        setSelectedMeetingId(e.target.value);
        const selected = futureMeetings.find(m => m.id === e.target.value);
        if (selected && onSelect) {
            onSelect(selected);
        }
    };

    return (
        <div className="member-future-meetings-selector">
            <Form.Label htmlFor="future-meeting-select">{label == null ? "Select a future meeting:" : label}</Form.Label>
            {loading ? (
                <Spinner animation="border" size="sm" />
            ) : (
                <Form.Select
                        id="future-meeting-select"
                        value={selectedMeetingId}
                        onChange={handleChange}
                        required={required}
                >
                    <option value="">-- Select --</option>
                    {futureMeetings.map(meeting => (
                        <option key={meeting.id} value={meeting.id}>
                            {meeting.title} ({new Date(meeting.date).toLocaleString()})
                        </option>
                    ))}
                </Form.Select>
            )}
        </div>
    );
};

MemberFutureMeetingsSelector.propTypes = {
    onSelect: PropTypes.func,
    label: PropTypes.string,
    required: PropTypes.bool
};

export default MemberFutureMeetingsSelector;